import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import styles from "./Jck.module.css";
import JCKLogo from "../../assets/images/JCK_Logo.png";
import IcDimond from "../../assets/icons/IcDimond";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { setHours, setMinutes, isWithinInterval } from "date-fns";
import centerDiamond from "../../assets/diamonds/diamond_hero.png";
import {
  FaChevronDown,
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaTag,
} from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import countryCode from "../../utils/countryCode.json";
import {
  updateField,
  validateForm,
  resetForm,
  setSubmitted,
} from "../../store/slices/jckFormSlice";
import {
  HiOutlineCalendarDays,
  HiOutlineMapPin,
  HiOutlineBuildingStorefront,
} from "react-icons/hi2";
import CountdownTimer from "../../components/common/CountdownTimer";
import {
  useBookEventMutation,
  useGetSlotsListQuery,
} from "../../store/api/eventApi";
import { toast } from "sonner";
import dayjs from "dayjs";

const SLOT_OPTIONS = [
  "11:00 AM",
  "11:30 AM",
  "12:00 PM",
  "12:30 PM",
  "1:00 PM",
  "1:30 PM",
  "2:00 PM",
  "2:30 PM",
  "3:00 PM",
  "3:30 PM",
  "4:00 PM",
];

const EXPO_DATES = [
  new Date(2025, 5, 6),
  new Date(2025, 5, 7),
  new Date(2025, 5, 8),
  new Date(2025, 5, 9),
];

const CustomDropdown = ({ value, options, onChange, placeholder, error }) => {
  const [open, setOpen] = useState(false);
  const handleSelect = (option) => {
    onChange(
      option?.flag ? option.callingCode : option.start ? option.start : option
    );
    setOpen(false);
  };
  return (
    <div
      className={`${styles.customDropdown} ${open ? styles.open : ""} ${
        error ? styles.error : ""
      }`}
      tabIndex={0}
      onBlur={() => setOpen(false)}
    >
      <div className={styles.selectedValue} onClick={() => setOpen((v) => !v)}>
        {value || <span className={styles.placeholder}>{placeholder}</span>}
        <FaChevronDown className={styles.dropdownIcon} />
      </div>
      {open && (
        <div className={styles.dropdownMenu}>
          {options.map((option) => (
            <div
              key={JSON.stringify(option)}
              className={`${styles.dropdownOption} ${
                option === value ? styles.selected : ""
              }`}
              onClick={() => handleSelect(option)}
            >
              {option?.flag ? (
                <div className="d-flex gap-2 align-items-center">
                  <img
                    src={option.flag}
                    height={"20px"}
                    width={"30px"}
                    loading="lazy"
                  />

                  <span>{option.callingCode}</span>
                </div>
              ) : (
                <>
                  {" "}
                  {option.start ? `${option.start} - ${option.end}` : option}
                </>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const Jck = () => {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      business: "",
      name: "",
      designation: "",
      phone: "",
      email: "",
      date: null,
      slot: "",
      countryCode: "+1",
      location: "",
    },
  });
  const { data: slotsData, isLoading: loadingSlots } = useGetSlotsListQuery();
  const availableDates = slotsData?.data?.availableDates;
  const watchDate = watch("date");
  const availableSlotsByDate =
    slotsData?.data?.slots?.[dayjs(watchDate).format("YYYY-MM-DD")];
  const [bookEvent, { data: eventBooked, isLoading: bookinInProgress }] =
    useBookEventMutation();
  const onSubmit = (data) => {
    let formData = structuredClone(data);
    formData.date = dayjs(formData.date).format("YYYY-MM-DD");
    delete formData.slot;
    bookEvent({
      ...formData,
      endTime: availableSlotsByDate?.find(
        (item) => item.start === formData?.startTime
      )?.end,
    })
      .unwrap()
      .then((result) => {
        toast.success(result.message);
        reset();
      })
      .catch((err) => {
        toast.error(err?.data?.message);
      });
  };

  useEffect(() => {
    document.body.classList.add("jck-page-bg");
    return () => {
      document.body.classList.remove("jck-page-bg");
      reset();
    };
  }, [reset]);

  return (
    <div className={styles.mainContainer}>
      {/* Hero Section */}
      <div className={styles.jckCircleMiddle} />
      <div className={styles.jckCircleOuter} />
      <div className={styles.jckCircleInner} />
      <section className={styles.jckheroSection}>
        <div className={styles.leftSection}>
          <div className={styles.headingRow}>
            <span className={styles.gradientHeading}>
              Honor us with your presence at the
            </span>
            <img src={JCKLogo} alt="JCK Logo" className={styles.jckLogo} />
          </div>
          <div className={styles.centerDiamondSection}>
            <div style={{ marginTop: "50px" }}>
              <CountdownTimer targetDate={new Date(2025, 5, 6, 10, 0, 0)} />
            </div>
            <img
              src={centerDiamond}
              alt="Diamond"
              className={styles.centerDiamondImg}
            />
          </div>
          <div className={styles.cardsRow}>
            <div className={styles.glassCard}>
              <div className={styles.cardIcon}>
                <HiOutlineCalendarDays />
              </div>
              <div className={styles.cardText}>06-09th June, 2025</div>
            </div>
            <div className={styles.glassCard}>
              <div className={styles.cardIcon}>
                <HiOutlineMapPin />
              </div>
              <div className={styles.cardText}>
                The Venetian Expo, Las Vegas
              </div>
            </div>
            <div className={styles.glassCard}>
              <div className={styles.cardIcon}>
                <HiOutlineBuildingStorefront />
              </div>
              <div className={styles.boothColumn}>
                <div className={styles.boothLabel}>Booth No</div>
                <div className={styles.cardText}>3147</div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.rightSection}>
          <h2 className={styles.formHeading}>
            Let's Collaborate to Lead What's Next
          </h2>
          <p className={styles.formSubheading}>
            Fill in your details, and we'll get in touch with you.
          </p>
          <form
            className={styles.form}
            onSubmit={handleSubmit(onSubmit)}
            style={{ width: "100%" }}
            noValidate
          >
            {/* Row 1: Company Name (full width) */}
            <div className={styles.inputGroup} style={{ gridColumn: "1 / -1" }}>
              <label className={styles.label} htmlFor="business">
                Company Name
              </label>
              <input
                id="business"
                {...register("business", {
                  required: "Company name is required",
                  minLength: {
                    value: 2,
                    message: "Company name must be at least 2 characters",
                  },
                })}
                type="text"
                className={`${styles.select} ${
                  errors.business ? styles.errorInput : ""
                }`}
                placeholder="Your Company"
                aria-invalid={!!errors.business}
                aria-describedby="business-error"
              />
              {errors.business && (
                <span className={styles.error} id="business-error">
                  {errors.business.message}
                </span>
              )}
            </div>
            {/* Row 2: Person Name & Designation */}
            <div className={styles.rightSectionRow}>
              <div className={styles.inputGroup}>
                <label className={styles.label} htmlFor="name">
                  Person Name
                </label>
                <input
                  id="name"
                  {...register("name", {
                    required: "Person name is required",
                    minLength: {
                      value: 2,
                      message: "Name must be at least 2 characters",
                    },
                  })}
                  type="text"
                  className={`${styles.select} ${
                    errors.name ? styles.errorInput : ""
                  }`}
                  placeholder="Your Name"
                  aria-invalid={!!errors.name}
                  aria-describedby="name-error"
                />
                {errors.name && (
                  <span className={styles.error} id="name-error">
                    {errors.name.message}
                  </span>
                )}
              </div>
              <div className={styles.inputGroup}>
                <label className={styles.label} htmlFor="designation">
                  Designation
                </label>
                <input
                  id="designation"
                  {...register("designation", {
                    required: "Designation is required",
                    minLength: {
                      value: 2,
                      message: "Designation must be at least 2 characters",
                    },
                  })}
                  type="text"
                  className={`${styles.select} ${
                    errors.designation ? styles.errorInput : ""
                  }`}
                  placeholder="Designation"
                  aria-invalid={!!errors.designation}
                  aria-describedby="designation-error"
                />
                {errors.designation && (
                  <span className={styles.error} id="designation-error">
                    {errors.designation.message}
                  </span>
                )}
              </div>
            </div>
            {/* Row 3: Email & Phone Number */}

            <div className={styles.inputGroup}>
              <label className={styles.label} htmlFor="phone">
                Phone Number
              </label>
              <div className="align-items-end d-flex gap-2">
                <div>
                  <Controller
                    name="countryCode"
                    control={control}
                    rules={{ required: "Country code is required" }}
                    render={({ field }) => (
                      <CustomDropdown
                        value={field.value}
                        options={countryCode}
                        onChange={field.onChange}
                        placeholder=""
                        error={!!errors.countryCode}
                      />
                    )}
                  />
                </div>
                <input
                  id="phone"
                  {...register("phone", {
                    required: "Phone number is required",
                    pattern: {
                      value: /^[+]?[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/,
                      message: "Please enter a valid phone number",
                    },
                  })}
                  type="tel"
                  className={`${styles.select} ${
                    errors.phone ? styles.errorInput : ""
                  }`}
                  placeholder="e.g. +1234567890"
                  aria-invalid={!!errors.phone}
                  aria-describedby="phone-error"
                />
              </div>

              {errors.phone && (
                <span className={styles.error} id="phone-error">
                  {errors.phone.message}
                </span>
              )}
            </div>

            <div className={styles.inputGroup}>
              <label className={styles.label} htmlFor="email">
                Email
              </label>
              <input
                id="email"
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Please enter a valid email address",
                  },
                })}
                type="email"
                className={`${styles.select} ${
                  errors.email ? styles.errorInput : ""
                }`}
                placeholder="you@example.com"
                aria-invalid={!!errors.email}
                aria-describedby="email-error"
              />
              {errors.email && (
                <span className={styles.error} id="email-error">
                  {errors.email.message}
                </span>
              )}
            </div>
            {/* Row 4: Date & Slot */}
            <div className={styles.rightSectionRow}>
              <div className={styles.inputGroup}>
                <label className={styles.label} htmlFor="date">
                  Date
                </label>

                <Controller
                  control={control}
                  name="date"
                  rules={{ required: "Date is required" }}
                  render={({ field }) => (
                    <DatePicker
                      onChange={(date) => field.onChange(date)}
                      placeholderText="Select Expo Date"
                      includeDates={availableDates}
                      calendarClassName={styles.datePickerCalendar}
                      popperClassName={styles.datePickerPopper}
                      dayClassName={(date) =>
                        EXPO_DATES.some(
                          (expoDate) =>
                            date.getFullYear() === expoDate.getFullYear() &&
                            date.getMonth() === expoDate.getMonth() &&
                            date.getDate() === expoDate.getDate()
                        )
                          ? styles.expoDay
                          : ""
                      }
                      customInput={
                        <input
                          className={styles.select}
                          style={{ cursor: "pointer" }}
                          readOnly
                          aria-invalid={!!errors.date}
                          aria-describedby="date-error"
                        />
                      }
                      selected={field.value}
                      dateFormat="dd/MM/yyyy"
                      className={styles.date}
                    />
                  )}
                />

                {errors.date && (
                  <span className={styles.error} id="date-error">
                    {errors.date.message}
                  </span>
                )}
              </div>
              <div className={styles.inputGroup}>
                <label className={styles.label} htmlFor="startTime">
                  Slot
                </label>
                <Controller
                  name="startTime"
                  control={control}
                  rules={{ required: "Time slot is required" }}
                  render={({ field }) => (
                    <CustomDropdown
                      value={field.value}
                      options={availableSlotsByDate || []}
                      onChange={field.onChange}
                      placeholder="Select a slot"
                      error={!!errors.startTime}
                    />
                  )}
                />
                {errors.startTime && (
                  <span className={styles.sloat} id="slot-error">
                    {errors.startTime.message}
                  </span>
                )}
              </div>
            </div>
            <div className={styles.inputGroup}>
              <label className={styles.label} htmlFor="location">
                Location
              </label>
              <input
                id="location"
                {...register("location", {
                  required: "Location is required",
                })}
                type="text"
                className={`${styles.select} ${
                  errors.name ? styles.errorInput : ""
                }`}
                placeholder="Your Location"
                aria-invalid={!!errors.name}
                aria-describedby="name-error"
              />
              {errors.location && (
                <span className={styles.error} id="name-error">
                  {errors.location.message}
                </span>
              )}
            </div>
            {/* Submit Button Row */}

            <button type="submit" className={styles.submitBtn}>
              {bookinInProgress ? "Booking Slot..." : "Book Now"}
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default Jck;
